import { EditorState } from "draft-js";
import { editorDecorators } from "editor/decorators";

export default function(content) {
  return EditorState.createWithContent(content, editorDecorators);
}
